/*eslint-disable*/
import Downshift from 'downshift'
import * as R from 'ramda'
import React, { useContext, useEffect, useReducer, useRef, useState } from 'react'

import { SideBarContext } from '@/SidePanel/SideBarContext'
import { EyeCloseIcon, EyeOpenIcon, InfoIcon, NextDetailICon } from '@/common/Icons/Icons'
// import { validateEmail } from '@/Flows/utils'
import { LoadingSvgImage } from '@/common/Icons/LoadingSvgImage'
import { WarningAlertIcon } from '@/common/Icons/Workflow.Icons'
import { Loader } from '@/common/components/Loader'
import { Modal } from '@/common/components/Modal'
import { Button } from '@/common/styled/Dialog.BotDetails.Dumb'
import { ButtonContainer, SmallButton } from '@/common/styled/Dialog.Canvas.Nodes.Dumb'
import { TabContainer, TabHeader, TabRow } from '@/common/styled/Settings.Dumb'
import {
    CancelButton,
    DropdownLi,
    DropdownUl,
    DropdownUlWrapper,
    Input,
    InputContainer,
    InputContent,
    InputWrapper
} from '@/common/styled/Workflow.Analytics.Dumb'
import { postMessage } from '@/common/user-sessions/across-tabs'
import { validateEmail } from '@/common/utils/common.utils'

import { isBlockedDomain } from '@/Profile/domain-utils'
import {
    getJson,
    getJsonwithCredentials,
    logEvent,
    loginApiURL,
    postJson,
    putJson,
    updatePasswordUrl
} from '@/common/utils/api-utils'
import { EyeType, Mode, Modes, PasswordType, initialData } from './types'

const errorMessages = {
    0: 'Email is invalid.',
    1: 'Email or password is incorrect',
    2: 'Only Corporate emails are allowed'
}

const capitalize = (string: any) =>
    R.ifElse(
        R.isEmpty,
        R.always(''),
        R.compose(R.flip(R.concat)(R.slice(1, Infinity, string)), R.toUpper, R.head)
    )(string)

const replaceUnAlpha = R.replace(/[^a-zA-Z]/g, '')

const normalize = (name: string) =>
    (name.length && name[0] + R.compose<string, string, string>(R.toLower, R.slice(1, Infinity))(name)) || ''

const allowOnlyAlpha: (val: string) => string = R.ifElse(
    R.isEmpty,
    R.always(''),
    R.compose(normalize, capitalize, replaceUnAlpha)
)

const PasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])(?=.{8,})/

export function Profile(props: any) {
    const initialData = {
        id: '',
        first_name: '',
        last_name: '',
        email: '',
        org: '',
        role: '',
        country: '',
        phone_number: '',
        phone_code: '',
        verified: false,
        phone_verified: false
    }

    const [profileData, setProfileData] = useState<any>(initialData)

    const [showOTPPopUp, setShowOTPPopUp] = useState(false)

    const [showEmailOTPPopUp, setShowEmailOTPPopUp] = useState(false)

    const [loading, setLoading] = useState(true)

    const [onSaveloading, setOnSaveLoading] = useState(false)

    const [dialCodeSearch, setDialCodeSearch] = useState<string>('')

    const [countrySearch, setCountrySearch] = useState<string>('')

    const [defaultProfileData, setDefaultProfileData] = useState<any>({})

    const [updateData, setUpdateData] = useState<any>({})

    const [otpValue, setOtpValue] = useState('')

    const [otpSent, setOtpSent] = useState(false)

    const [sendOTPLoader, setSendOTPLoader] = useState<boolean>(false)
    const [sendEmailOTPLoader, setSendEmailOTPLoader] = useState<boolean>(false)

    // const [sendMobileOTPLoader, setoMobileSendOTPLoader] = useState<boolean>(false)
    // const [verifyMobileOTPLoader, setVerifyMobileOTPLoader] = useState<boolean>(false)
    const [mobileOtpSent, setMobileOtpSent] = useState(false)

    const [sendOTPError, setSendOTPError] = useState<boolean>(false)

    const [sendEmailOTPError, setSendEmailOTPError] = useState<boolean>(false)

    const [verifyOTPLoader, setVerifyOTPLoader] = useState<boolean>(false)
    const [verifyOTPError, setVerifyOTPError] = useState<boolean>(false)

    const { refetchProfileData } = useContext(SideBarContext)
    
    const retry = () =>
    getJson(updatePasswordUrl('/user_info')).then((res: any) => {
        getJson(updatePasswordUrl('/users/countries')).then(countriesres => {
            getJson(updatePasswordUrl('/countrycodes')).then(countrycodesres => {
        // Promise.resolve({"phone_number":{"id":6,"mobileNo":"7395938926","verified":true,"valid":true,"createdAt":"2021-06-27T19:49:43.000Z","updatedAt":"2021-06-27T19:50:36.000Z","code":"1","userId":50},"id":50,"first_name":"Abinaya","last_name":"Kumarasamy","email":"selva.g@skitter.in","org":"null","role":"null","country":"IN","verified":true} as any)
        //     .then((res: any) => {
        //         Promise.resolve([{"name":"Andorra","ISOcode":"AD"},{"name":"United Arab Emirates","ISOcode":"AE"},{"name":"Afghanistan","ISOcode":"AF"},{"name":"Antigua and Barbuda","ISOcode":"AG"},{"name":"Anguilla","ISOcode":"AI"},{"name":"Albania","ISOcode":"AL"},{"name":"Armenia","ISOcode":"AM"},{"name":"Angola","ISOcode":"AO"},{"name":"India","ISOcode":"IN"},{"name":"Antarctica","ISOcode":"AQ"},{"name":"Argentina","ISOcode":"AR"},{"name":"American Samoa","ISOcode":"AS"},{"name":"Austria","ISOcode":"AT"},{"name":"Australia","ISOcode":"AU"},{"name":"Aruba","ISOcode":"AW"},{"name":"Åland Islands","ISOcode":"AX"},{"name":"Azerbaijan","ISOcode":"AZ"},{"name":"Bosnia and Herzegovina","ISOcode":"BA"},{"name":"Barbados","ISOcode":"BB"},{"name":"Bangladesh","ISOcode":"BD"},{"name":"Belgium","ISOcode":"BE"},{"name":"Burkina Faso","ISOcode":"BF"},{"name":"Bulgaria","ISOcode":"BG"},{"name":"Bahrain","ISOcode":"BH"},{"name":"Burundi","ISOcode":"BI"},{"name":"Benin","ISOcode":"BJ"},{"name":"Saint Barthélemy","ISOcode":"BL"},{"name":"Bermuda","ISOcode":"BM"},{"name":"Brunei Darussalam","ISOcode":"BN"},{"name":"Bolivia (Plurinational State of)","ISOcode":"BO"},{"name":"Bonaire, Sint Eustatius and Saba","ISOcode":"BQ"},{"name":"Brazil","ISOcode":"BR"},{"name":"Bahamas","ISOcode":"BS"},{"name":"Bhutan","ISOcode":"BT"},{"name":"Bouvet Island","ISOcode":"BV"},{"name":"Botswana","ISOcode":"BW"},{"name":"Belarus","ISOcode":"BY"},{"name":"Belize","ISOcode":"BZ"},{"name":"Canada","ISOcode":"CA"},{"name":"Cocos (Keeling) Islands","ISOcode":"CC"},{"name":"Congo (Democratic Republic of the)","ISOcode":"CD"},{"name":"Central African Republic","ISOcode":"CF"},{"name":"Congo","ISOcode":"CG"},{"name":"Switzerland","ISOcode":"CH"},{"name":"Côte d'Ivoire","ISOcode":"CI"},{"name":"Cook Islands","ISOcode":"CK"},{"name":"Chile","ISOcode":"CL"},{"name":"Cameroon","ISOcode":"CM"},{"name":"China","ISOcode":"CN"},{"name":"Colombia","ISOcode":"CO"},{"name":"Costa Rica","ISOcode":"CR"},{"name":"Cuba","ISOcode":"CU"},{"name":"Cabo Verde","ISOcode":"CV"},] as any).then(countriesres => {
        //             Promise.resolve([{"ISO_code":"IN","country_code":"91"},{"ISO_code":"PK","country_code":"92"},{"ISO_code":"AF","country_code":"93"},{"ISO_code":"LK","country_code":"94"},{"ISO_code":"MM","country_code":"95"},{"ISO_code":"MV","country_code":"960"},{"ISO_code":"LB","country_code":"961"},{"ISO_code":"JO","country_code":"962"},{"ISO_code":"SY","country_code":"963"},{"ISO_code":"IQ","country_code":"964"},{"ISO_code":"KW","country_code":"965"},{"ISO_code":"SA","country_code":"966"},{"ISO_code":"YE","country_code":"967"},{"ISO_code":"OM","country_code":"968"},{"ISO_code":"PS","country_code":"970"},{"ISO_code":"AE","country_code":"971"},{"ISO_code":"IL","country_code":"972"},{"ISO_code":"BH","country_code":"973"},{"ISO_code":"QA","country_code":"974"},{"ISO_code":"BT","country_code":"975"},{"ISO_code":"MN","country_code":"976"},{"ISO_code":"NP","country_code":"977"},{"ISO_code":"IR","country_code":"98"},{"ISO_code":"TJ","country_code":"992"},{"ISO_code":"TM","country_code":"993"},{"ISO_code":"AZ","country_code":"994"},{"ISO_code":"GE","country_code":"995"},{"ISO_code":"KG","country_code":"996"},{"ISO_code":"UZ","country_code":"998"}] as any).then(countrycodesres => {
                    setCountryCodeArray(countrycodesres)
                    setCountryArray(countriesres)
                    const { id, first_name, last_name, email, org, role, country, verified } = res
                    const emailVerified = verified
                    if (res.phone_number != null) {
                        const { mobileNo, code, verified } = res.phone_number

                        setDefaultProfileData({
                            id,
                            first_name,
                            last_name,
                            email,
                            org: org ? org : '',
                            role: role ? role : '',
                            country,
                            phone_number: mobileNo,
                            phone_code: code,
                            verified: emailVerified,
                            phone_verified: verified
                        })
                        setProfileData({
                            id,
                            first_name,
                            last_name,
                            email,
                            org: org ? org : '',
                            role: role ? role : '',
                            country,
                            phone_number: mobileNo,
                            phone_code: code,
                            verified: emailVerified,
                            phone_verified: verified
                        })
                    } else {
                        const phone_code = countrycodesres
                            .filter((data: any) => data.ISO_code == country)
                            .map((data: any) => data.country_code)
                            .pop()

                        setDefaultProfileData({
                            id,
                            first_name,
                            last_name,
                            email,
                            org: org ? org : '',
                            role: role ? role : '',
                            country,
                            phone_number: '',
                            phone_code: phone_code ? phone_code : '',
                            verified: emailVerified,
                            phone_verified: false
                        })
                        setProfileData({
                            id,
                            first_name,
                            last_name,
                            email,
                            org: org ? org : '',
                            role: role ? role : '',
                            country,
                            phone_number: '',
                            phone_code: phone_code ? phone_code : '',
                            verified: emailVerified,
                            phone_verified: false
                        })
                    }
                    setShowEmailOTPPopUp(props.location.search.includes('verify'))
                    setLoading(false)
                })
            })
        })
    useEffect(() => {
        retry()
    }, [])

    useEffect(() => {
        props.location.search.includes('verify-') && !showEmailOTPPopUp && setShowEmailOTPPopUp(true)
    }, [props.location.search])

    const sendOTP = (resend?: boolean) => {
        setSendOTPLoader(true)
        const { email } = profileData
        const mobile_number = profileData.phone_number
        const country_code = profileData.phone_code

        postJson(updatePasswordUrl('/send_otp'))({
            email,
            mobile_number,
            country_code
        })
            .then(response => {
                resend && resend == true && setMobileOtpSent(true)
                setSendOTPLoader(false)
                setShowOTPPopUp(true)
                setOtpValue('')
            })
            .catch(err => {
                setSendOTPLoader(false)
                setSendOTPError(true)
            })
    }

    const sendEmailOTP = (resend?: boolean) => {
        const { email } = profileData
        setSendEmailOTPLoader(true)

        postJson(loginApiURL('/twilio_send_otp'))({ email: email })
            .then(() => {
                resend && resend == true && setOtpSent(true)
                setSendEmailOTPLoader(false)
                setOtpValue('')
                setShowEmailOTPPopUp(true)
            })
            .catch(error => {
                setSendEmailOTPLoader(false)
                setSendEmailOTPError(error.response && error.response.data.error ? error.response.data.error : true)
            })
    }

    const verifyOTP = () => {
        const { email } = profileData

        if (showEmailOTPPopUp) {
            setVerifyOTPLoader(true)
            postJson(loginApiURL('/twilio_verify_otp'))({
                email,
                otp: otpValue
            })
                .then(response => {
                    setShowEmailOTPPopUp(false)
                    setVerifyOTPLoader(false)
                    setDefaultProfileData((e: any) => ({
                        ...e,
                        verified: true,
                        email: email
                    }))
                    refetchProfileData()
                    setOtpValue('')
                    setOtpSent(false)
                    props.history.replace(`/workspace/${props.match.params.workspacename}/profile`)
                })
                .catch(error => {
                    setVerifyOTPLoader(false)
                    setVerifyOTPError(error.response && error.response.data.error ? error.response.data.error : true)
                })
        } else {
            const mobile_number = profileData.phone_number
            const country_code = profileData.phone_code

            setVerifyOTPLoader(true)
            postJson(updatePasswordUrl('/verify_otp'))({
                email,
                mobile_number,
                country_code,
                otp: otpValue
            })
                .then(response => {
                    setShowOTPPopUp(false)
                    setVerifyOTPLoader(false)
                    setDefaultProfileData((e: any) => ({
                        ...e,
                        phone_number: mobile_number,
                        phone_code: country_code,
                        phone_verified: true
                    }))
                    setMobileOtpSent(false)
                })
                .catch(error => {
                    setVerifyOTPLoader(false)
                    setVerifyOTPError(true)
                })
        }
    }

    useEffect(() => {
        if (Object.entries(defaultProfileData).length > 0) {
            isObjectChanged()
        }
    }, [profileData])

    const isObjectChanged = () => {
        const currentData = Object.entries(profileData)
        const defaultDataKeys = Object.keys(defaultProfileData)
        const defaultData = Object.values(defaultProfileData)
        const isDataChanged = currentData.filter(val => {
            if (
                val[0] == 'phone_number' ||
                val[0] == 'phone_code' ||
                val[0] == 'phone_verified' ||
                val[0] == 'email' ||
                val[0] == 'verified'
            ) {
                return false
            }
            const i = defaultDataKeys.indexOf(val[0])
            return i > -1 && defaultData[i] !== val[1]
        })

        setUpdateData(
            isDataChanged.reduce((acc, current) => {
                if (current[0] == 'country') {
                    acc['country_code'] = current[1]
                } else {
                    acc[current[0]] = current[1]
                }
                return acc
            }, {})
        )
    }

    const updateProfile = () => {
        setOnSaveLoading(true)
        const { phone_verified, ...rest } = updateData
        putJson(updatePasswordUrl('/user_info'))()({
            ...rest
        })
            .then(()=> {
                logEvent(props.match.params.workspacename, {
                    event:"EVENT::PROFILE::UPDATE_DETAILS",event_meta:{}
                })
               return retry()
            })
            .then(_ => {
                setOnSaveLoading(false)
            })
    }

    const [countryArray, setCountryArray] = useState<any>([])

    const [showCountryDropDown, setShowCountryDropDown] = useState(false)

    const getCountryName = (code: string, search: string) => {
        if (showCountryDropDown) {
            return search
        } else {
            return countryArray.length
                ? code && code != ''
                    ? countryArray.filter((e: any) => e.ISOcode == code).pop().name
                    : ''
                : ''
        }
    }
    const [countryCodeArray, setCountryCodeArray] = useState<any[]>([])

    const [showCountryCodeDropDown, setShowCountryCodeDropDown] = useState(false)

    const assignDigitalCode = (codes: any[], data: any, dialCodeSearch: string, dropDownOpen: boolean) => {
        if (dropDownOpen) {
            return dialCodeSearch
        } else {
            if (data.phone_code == '') {
                return '+ '
            } else {
                return `+ ${data.phone_code}`
            }
        }
    }

    // const [profileView, setProfileView] = useState<boolean>(true)
    const [profileView, setProfileView] = useState<'Personal details' | 'Change password' | 'Multi factor authentication'>('Personal details')

    const verifyNeeded = (profileData: any): boolean => {
        const { phone_code, phone_number, phone_verified } = defaultProfileData
        if (profileData.phone_code != phone_code) {
            return true
        } else if (profileData.phone_number != phone_number) {
            return true
        } else if (phone_verified == false) {
            return true
        }
        return false
    }

    const test = (acc: any[], val: any) =>
        acc.every((e: any) => e.country_code != val.country_code) ? acc.concat(val) : acc

    const disableState = () => {
        if (profileData.first_name.length < 1) return true
        else if (profileData.last_name.length < 1) return true
        else if (profileData.org.trim().length < 1) return true
        else if (profileData.role.trim().length < 1) return true
        else return Object.entries(updateData).length === 0
    }

    return loading === true ? (
        <Loader.PageLoader show={true} />
    ) : (
        <>
            <section className="cogni_cards tour_automation_canvas">
                <div className="header_box_shadow" />
                <div className="flow_canvas1">
                    <div className="flex_canvas1">
                        <div className="flex_menu1 flow_group_home">
                            <div className="indent_dialog_left">
                                <div className="indent_left">
                                    <div className="indent_title  mb-0">Profile</div>
                                </div>
                            </div>
                        </div>
                        <div className="flex_side_menu1 intent_home flow_group_home">
                            <div className="intent_dialog_right" />
                        </div>
                    </div>
                </div>
            </section>

            <div className="entity_cards entity_cards_without_scroll">
                <div className="col-md-12 profile_page_form">
                    <div className="row">
                        <div className="profile_page_uform">
                            <TabContainer>
                                <TabRow>
                                    <TabHeader
                                        active={profileView == 'Personal details'}
                                        onClick={() => setProfileView('Personal details')}
                                    >
                                        Personal details
                                    </TabHeader>
                                    <TabHeader
                                        active={profileView == 'Change password'}
                                        onClick={() => setProfileView('Change password')}
                                    >
                                        Change password
                                    </TabHeader>
                                    {/* <TabHeader
                                        active={profileView == 'Change password'}
                                        onClick={() => setProfileView('Change password')}
                                    >
                                        Business hours
                                    </TabHeader> */}
                                    <TabHeader
                                        active={profileView == 'Multi factor authentication'}
                                        onClick={() => setProfileView('Multi factor authentication')}
                                    >
                                        Multi-Factor Authentication
                                    </TabHeader>
                                </TabRow>
                            </TabContainer>
                            <div className="profile_form-page">
                                <h4>{profileView == 'Personal details' ? 'Personal details' : profileView == 'Change password' ? 'Change password' : ''}</h4>
                                {showOTPPopUp ? (
                                    <Modal>
                                        <div className="otp_popup">
                                            <h4>Enter OTP</h4>
                                            <input
                                                type="text"
                                                value={otpValue}
                                                placeholder="Enter your 4 digit OTP"
                                                onChange={e => {
                                                    setOtpValue(e.target.value)
                                                    verifyOTPError ? setVerifyOTPError(false) : null
                                                }}
                                            />
                                            {verifyOTPError ? (
                                                <span className="error_otp_msg">
                                                    <div className="error_input_show">
                                                        <svg x="0px" y="0px" viewBox="0 0 483.5 483.5">
                                                            <path d="M480 425L269.1 29.9c-5.3-9.9-15.6-16.1-26.8-16.1-11.2 0-21.5 6.2-26.8 16.1L3.6 425c-5 9.5-4.8 20.9.7 30 5.5 9.1 15.4 14.8 26.1 14.8h422.7c10.7 0 20.6-5.6 26.1-14.8 5.5-9.2 5.8-20.5.8-30zm-237.8-16c-16.8 0-30.4-13.6-30.4-30.4s13.6-30.4 30.4-30.4c16.8 0 30.4 13.6 30.4 30.4S259 409 242.2 409zm30.5-121.1c0 16.8-13.6 30.4-30.4 30.4-16.8 0-30.4-13.6-30.4-30.4V166.3c0-16.8 13.6-30.4 30.4-30.4 16.8 0 30.4 13.6 30.4 30.4v121.6z" />
                                                        </svg>
                                                        <span className="error_menu_hvr">
                                                            Invalid OTP or Something went wrong, Please try again!
                                                        </span>
                                                    </div>
                                                </span>
                                            ) : null}
                                            <p
                                                onClick={() => sendOTP(true)}
                                                className={
                                                    mobileOtpSent
                                                        ? 'resend_otp_mobile_profile email_resend success justify-content-end'
                                                        : 'resend_otp_mobile_profile email_resend justify-content-end'
                                                }
                                            >
                                                Resend OTP
                                            </p>
                                            {sendOTPLoader ? (
                                                <span>
                                                    <img
                                                        title="loader"
                                                        className="otp_img_inside"
                                                        src={LoadingSvgImage}
                                                    />
                                                </span>
                                            ) : null}
                                            <ButtonContainer className="p-0">
                                                <Button
                                                    primary
                                                    onClick={() => {
                                                        setVerifyOTPError(false)
                                                        setShowOTPPopUp(false)
                                                        setProfileData((data: any) => ({
                                                            ...data,
                                                            phone_number: defaultProfileData.phone_number
                                                        }))
                                                    }}
                                                >
                                                    <label>Cancel</label>
                                                </Button>
                                                <Button onClick={verifyOTP} disabled={verifyOTPError}>
                                                    <label>Submit</label>
                                                </Button>
                                            </ButtonContainer>
                                        </div>
                                    </Modal>
                                ) : null}

                                {showEmailOTPPopUp ? (
                                    <Modal>
                                        {/* <div className="otp_popup">
                                            <div className="login_bg_width_left_right_form">
                                                <InputWithLabel
                                                    type="text"
                                                    label="Enter OTP"
                                                    placeHolder="Enter your 4 digit OTP"
                                                    additionClass=""
                                                    disabled={false}
                                                    value={otpValue}
                                                    onChange={(e: any) => {
                                                        setOtpValue(e)
                                                        verifyOTPError ? setVerifyOTPError(false) : null
                                                    }}
                                                    maxLength={6}
                                                />
                                            </div> */}

                                        <div className="otp_popup">
                                            <h4>Enter OTP</h4>
                                            <input
                                                type="number"
                                                value={otpValue}
                                                placeholder="Enter your 6 digit OTP"
                                                onChange={(e: any) => {
                                                    if (e.target.value.length < 7) {
                                                        setOtpValue(e.target.value)
                                                        verifyOTPError ? setVerifyOTPError(false) : null
                                                    }
                                                }}
                                            />
                                            {verifyOTPError || typeof verifyOTPError == 'string' ? (
                                                <span className="error_otp_msg">
                                                    <div className="error_input_show">
                                                        <svg x="0px" y="0px" viewBox="0 0 483.5 483.5">
                                                            <path d="M480 425L269.1 29.9c-5.3-9.9-15.6-16.1-26.8-16.1-11.2 0-21.5 6.2-26.8 16.1L3.6 425c-5 9.5-4.8 20.9.7 30 5.5 9.1 15.4 14.8 26.1 14.8h422.7c10.7 0 20.6-5.6 26.1-14.8 5.5-9.2 5.8-20.5.8-30zm-237.8-16c-16.8 0-30.4-13.6-30.4-30.4s13.6-30.4 30.4-30.4c16.8 0 30.4 13.6 30.4 30.4S259 409 242.2 409zm30.5-121.1c0 16.8-13.6 30.4-30.4 30.4-16.8 0-30.4-13.6-30.4-30.4V166.3c0-16.8 13.6-30.4 30.4-30.4 16.8 0 30.4 13.6 30.4 30.4v121.6z" />
                                                        </svg>
                                                        <span className="error_menu_hvr">
                                                            {typeof verifyOTPError == 'string'
                                                                ? verifyOTPError
                                                                : 'Invalid OTP or Something went wrong, Please try again!'}
                                                        </span>
                                                    </div>
                                                </span>
                                            ) : null}

                                            {verifyOTPLoader ? (
                                                <span>
                                                    <img
                                                        title="loading"
                                                        className="otp_img_inside"
                                                        src={LoadingSvgImage}
                                                    />
                                                </span>
                                            ) : null}
                                            <ButtonContainer
                                                className="p-0"
                                                style={{ alignItems: 'center', marginTop: 10 }}
                                            >
                                                <Button
                                                    onClick={verifyOTP}
                                                    disabled={verifyOTPError || otpValue.length < 6}
                                                    className={
                                                        verifyOTPError || otpValue.length < 6
                                                            ? 'editor_btn_disabled'
                                                            : ''
                                                    }
                                                >
                                                    <label>Submit</label>
                                                </Button>
                                                <Button
                                                    primary
                                                    onClick={() => {
                                                        setVerifyOTPError(false)
                                                        setShowEmailOTPPopUp(false)
                                                        setOtpValue('')
                                                        setOtpSent(false)
                                                        props.history.replace(
                                                            `/workspace/${props.match.params.workspacename}/profile`
                                                        )
                                                    }}
                                                >
                                                    <label>Cancel</label>
                                                </Button>
                                                <p
                                                    onClick={() => sendEmailOTP(true)}
                                                    className={
                                                        otpSent
                                                            ? 'resend_otp_mobile_profile email_resend success'
                                                            : 'resend_otp_mobile_profile email_resend'
                                                    }
                                                >
                                                    Resend OTP
                                                </p>
                                            </ButtonContainer>
                                        </div>
                                    </Modal>
                                ) : null}

                                {sendOTPError ? (
                                    <Modal>
                                        <div className="otp_popup">
                                            <h5>'Invalid mobile number or Something went wrong.' Please try again.</h5>

                                            {/* <p>Please Try Again After some time</p> */}
                                            <Button
                                                primary
                                                // className="m-0 justify-content-center"
                                                onClick={() => {
                                                    setSendOTPError(false)
                                                    setProfileData((data: any) => ({
                                                        ...data,
                                                        phone_number: defaultProfileData.phone_number
                                                    }))
                                                }}
                                                style={{ minWidth: 'max-content' }}
                                            >
                                                <label>Okay</label>
                                            </Button>
                                        </div>
                                    </Modal>
                                ) : null}

                                {profileView == 'Personal details' && (
                                    <div className="login_bg_width_left_right_form">
                                        <div className="col-md-12 col-lg-12 form_w100">
                                            <div className='from_input_section'>
                                                {profileData.first_name.length == 0 && 
                                                    <>
                                                        <div className='profile_input_error_section'>
                                                            <span className='profile_input_error_info_icon'>
                                                                <WarningAlertIcon/>
                                                            </span>
                                                            <p className='profile_input_error'>Fisrt name cannot be empty</p>
                                                        </div>
                                                    </>
                                                }
                                                <InputWithLabel
                                                    type="text"
                                                    label="First name"
                                                    placeHolder="Enter your first name"
                                                    additionClass=""
                                                    disabled={false}
                                                    value={profileData.first_name}
                                                    onChange={v => {
                                                        setProfileData({
                                                            ...profileData,
                                                            first_name: allowOnlyAlpha(v)
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className='from_input_section'>
                                                {profileData.last_name.length == 0 && 
                                                    <>
                                                    <div className='profile_input_error_section'>
                                                        <span className='profile_input_error_info_icon'>
                                                            <WarningAlertIcon/>
                                                        </span>
                                                        <p className='profile_input_error'>Last name cannot be empty</p>
                                                    </div>
                                                    </>
                                                }
                                                <InputWithLabel
                                                    type="text"
                                                    label="Last name"
                                                    placeHolder="Enter your last name"
                                                    additionClass=""
                                                    disabled={false}
                                                    value={profileData.last_name}
                                                    onChange={v => {
                                                        setProfileData({
                                                            ...profileData,
                                                            last_name: allowOnlyAlpha(v)
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="profile_email">
                                                <InputWithLabel
                                                    type="text"
                                                    label="User email"
                                                    placeHolder="Enter your email id"
                                                    additionClass=""
                                                    disabled={false}
                                                    value={profileData.email}
                                                    onChange={v => {
                                                        setProfileData({
                                                            ...profileData,
                                                            email: v
                                                        })
                                                        setSendEmailOTPError(false)
                                                    }}
                                                    autoFocus={props.location.search.includes('change-email')}
                                                />
                                                {!defaultProfileData.verified ||
                                                defaultProfileData.email != profileData.email ? (
                                                    <>
                                                        <SmallButton
                                                            className={
                                                                !validateEmail(profileData.email) ||
                                                                sendEmailOTPError ||
                                                                isBlockedDomain(profileData.email)
                                                                    ? 'upload_profile_change_content email_veriy_label editor_btn_disabled'
                                                                    : 'upload_profile_change_content email_veriy_label'
                                                            }
                                                            onClick={sendEmailOTP}
                                                            disabled={
                                                                !validateEmail(profileData.email) ||
                                                                sendEmailOTPError ||
                                                                isBlockedDomain(profileData.email)
                                                            }
                                                        >
                                                            <label>Verify</label>
                                                        </SmallButton>
                                                        {sendEmailOTPLoader ? (
                                                            // <span>
                                                            <img
                                                                className="loader_otp email_otp_loader"
                                                                src={LoadingSvgImage}
                                                            />
                                                        ) : null}
                                                        {(sendEmailOTPError ||
                                                            (profileData.email.length > 0 &&
                                                                (!validateEmail(profileData.email) ||
                                                                    isBlockedDomain(profileData.email)))) && (
                                                            <div className="error_input_show intent_profile">
                                                                <WarningAlertIcon />
                                                                <span className="error_menu_hvr">
                                                                    {typeof sendEmailOTPError == 'string'
                                                                        ? sendEmailOTPError
                                                                        : !validateEmail(profileData.email)
                                                                        ? errorMessages[0]
                                                                        : isBlockedDomain(profileData.email)
                                                                        ? errorMessages[2]
                                                                        : 'Something went wrong. Please try again.'}
                                                                </span>
                                                            </div>
                                                        )}
                                                    </>
                                                ) : (
                                                    <SmallButton
                                                        className="upload_profile_change_content email_veriy_label verified_button"
                                                        style={{ pointerEvents: 'none', marginTop: 14 }}
                                                    >
                                                        <label>Verified</label>
                                                    </SmallButton>
                                                )}
                                            </div>

                                            <div className="profile__otp d-flex position-relative">
                                                <div className="country_code">
                                                    <InputWrapper>
                                                        <InputContainer>
                                                            <Input
                                                                type="text"
                                                                disabled={false}
                                                                value={assignDigitalCode(
                                                                    countryCodeArray,
                                                                    profileData,
                                                                    dialCodeSearch,
                                                                    showCountryCodeDropDown
                                                                )}
                                                                onChange={(e: any) => setDialCodeSearch(e.target.value)}
                                                                onClick={() => setShowCountryCodeDropDown(true)}
                                                            />
                                                            <div className="d-flex arrow_right_icon">
                                                                <NextDetailICon />
                                                            </div>
                                                            <InputContent></InputContent>
                                                            <DropdownUlWrapper className="m-0">
                                                                {showCountryCodeDropDown && (
                                                                    <Downshift
                                                                        isOpen={true}
                                                                        onOuterClick={() => {
                                                                            setShowCountryCodeDropDown(false)
                                                                            setDialCodeSearch('')
                                                                        }}
                                                                    >
                                                                        {() => (
                                                                            <div
                                                                                className=""
                                                                                role="combobox"
                                                                                aria-expanded="true"
                                                                                aria-haspopup="listbox"
                                                                                aria-owns="downshift-17-menu"
                                                                                aria-labelledby="downshift-17-label"
                                                                            >
                                                                                <DropdownUl>
                                                                                    {countryCodeArray
                                                                                        .reduce(test, [])
                                                                                        .filter(e =>
                                                                                            dialCodeSearch == ''
                                                                                                ? true
                                                                                                : e.country_code.startsWith(
                                                                                                      dialCodeSearch
                                                                                                  )
                                                                                        )
                                                                                        .map((e: any, i: number) => (
                                                                                            <DropdownLi
                                                                                                key={i}
                                                                                                onClick={() => {
                                                                                                    setProfileData({
                                                                                                        ...profileData,
                                                                                                        phone_code:
                                                                                                            e.country_code
                                                                                                    })
                                                                                                    setShowCountryCodeDropDown(
                                                                                                        false
                                                                                                    )
                                                                                                    setDialCodeSearch(
                                                                                                        ''
                                                                                                    )
                                                                                                }}
                                                                                            >
                                                                                                {'+ '}
                                                                                                {e.country_code}
                                                                                            </DropdownLi>
                                                                                        ))}
                                                                                </DropdownUl>
                                                                            </div>
                                                                        )}
                                                                    </Downshift>
                                                                )}
                                                            </DropdownUlWrapper>
                                                        </InputContainer>
                                                    </InputWrapper>
                                                </div>

                                                {profileData.phone_number.trim() == '' ? null : verifyNeeded(
                                                      profileData
                                                  ) ? (
                                                    <>
                                                        <SmallButton
                                                            className="upload_profile_change_content"
                                                            onClick={sendOTP}
                                                        >
                                                            <label>Verify</label>
                                                        </SmallButton>
                                                        {sendOTPLoader ? (
                                                            // <span>
                                                            <img className="loader_otp" src={LoadingSvgImage} />
                                                        ) : null}
                                                    </>
                                                ) : defaultProfileData.phone_verified == true ? (
                                                    <SmallButton
                                                        className="upload_profile_change_content verified_button"
                                                        style={{ pointerEvents: 'none' }}
                                                    >
                                                        <label>Verified</label>
                                                    </SmallButton>
                                                ) : null}
                                                <InputWrapper>
                                                    <InputContainer>
                                                        <Input
                                                            type="number"
                                                            className="mobile_num_global"
                                                            value={profileData.phone_number}
                                                            onChange={(e: any) => {
                                                                setProfileData({
                                                                    ...profileData,
                                                                    phone_number: e.target.value
                                                                })
                                                            }}
                                                        />
                                                        <InputContent>Phone number</InputContent>
                                                    </InputContainer>
                                                </InputWrapper>
                                            </div>
                                            <div className='from_input_section'>
                                                {profileData.org.length == 0 && 
                                                    <>
                                                        <span className='profile_input_error_section'>
                                                            <span className='profile_input_error_info_icon'>
                                                                <WarningAlertIcon/>
                                                            </span>
                                                            <p className='profile_input_error'>Organisation cannot be empty</p>
                                                        </span>
                                                    </>
                                                }
                                                <InputWithLabel
                                                    type="text"
                                                    label="Organisation"
                                                    placeHolder="Enter your organisation name"
                                                    additionClass=""
                                                    disabled={false}
                                                    value={profileData.org}
                                                    onChange={v => {
                                                        setProfileData({
                                                            ...profileData,
                                                            org: v
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className='from_input_section'>
                                                {profileData.role.length == 0 && 
                                                    <>
                                                        <span className='profile_input_error_section'>
                                                            <span className='profile_input_error_info_icon'>
                                                                <WarningAlertIcon/>
                                                            </span>
                                                            <p className='profile_input_error'>Role cannot be empty</p>
                                                        </span>
                                                    </>
                                                }
                                                <InputWithLabel
                                                    type="text"
                                                    label="Job role"
                                                    placeHolder="Enter your job role"
                                                    additionClass=""
                                                    disabled={false}
                                                    value={profileData.role}
                                                    onChange={v => {
                                                        setProfileData({
                                                            ...profileData,
                                                            role: v
                                                        })
                                                    }}
                                                />
                                            </div>

                                            <div className="country_zones">
                                                <>
                                                    <InputWithLabel
                                                        type="text"
                                                        label="Country"
                                                        placeHolder="Select Country"
                                                        additionClass=""
                                                        disabled={false}
                                                        value={getCountryName(profileData.country, countrySearch)}
                                                        onClick={() => {
                                                            setCountrySearch(
                                                                getCountryName(profileData.country, countrySearch)
                                                            )
                                                            setShowCountryDropDown(true)
                                                        }}
                                                        onChange={value => setCountrySearch(value)}
                                                    />
                                                    <DropdownUlWrapper className="m-0">
                                                        {showCountryDropDown && (
                                                            <Downshift
                                                                isOpen={true}
                                                                onOuterClick={() => setShowCountryDropDown(false)}
                                                            >
                                                                {() => (
                                                                    <div
                                                                        className="dropdown_right_entity"
                                                                        role="combobox"
                                                                        aria-expanded="true"
                                                                        aria-haspopup="listbox"
                                                                        aria-owns="downshift-17-menu"
                                                                        aria-labelledby="downshift-17-label"
                                                                        style={{ marginTop: -20 }}
                                                                    >
                                                                        <DropdownUl>
                                                                            {countryArray
                                                                                .filter((e: any) =>
                                                                                    countrySearch == ''
                                                                                        ? true
                                                                                        : e.name
                                                                                              .toLowerCase()
                                                                                              .startsWith(
                                                                                                  countrySearch.toLowerCase()
                                                                                              )
                                                                                )
                                                                                .map((element: any, index: number) => (
                                                                                    <DropdownLi
                                                                                        key={index}
                                                                                        onClick={(v: any) => {
                                                                                            if (
                                                                                                profileData.phone_number ==
                                                                                                ''
                                                                                            ) {
                                                                                                const phone_code = countryCodeArray
                                                                                                    .filter(
                                                                                                        (data: any) =>
                                                                                                            data.ISO_code ==
                                                                                                            element.ISOcode
                                                                                                    )
                                                                                                    .map(
                                                                                                        (data: any) =>
                                                                                                            data.country_code
                                                                                                    )
                                                                                                    .pop()
                                                                                                setProfileData({
                                                                                                    ...profileData,
                                                                                                    phone_code: phone_code
                                                                                                        ? phone_code
                                                                                                        : '',
                                                                                                    country:
                                                                                                        element.ISOcode
                                                                                                })
                                                                                            } else {
                                                                                                setProfileData({
                                                                                                    ...profileData,
                                                                                                    country:
                                                                                                        element.ISOcode
                                                                                                })
                                                                                            }
                                                                                            setShowCountryDropDown(
                                                                                                false
                                                                                            )
                                                                                        }}
                                                                                    >
                                                                                        {element.name}
                                                                                    </DropdownLi>
                                                                                ))}
                                                                        </DropdownUl>
                                                                    </div>
                                                                )}
                                                            </Downshift>
                                                        )}
                                                    </DropdownUlWrapper>
                                                </>
                                            </div>

                                            {/* <div className="upload_profile form-group col-md-6 col-lg-6 form_w50 form_w50_pr">
                                            <h6>Profile Picture</h6>
                                            <div className="upload_profile_width">
                                                <div className="upload_profile_img">
                                                    <img src="../photo.png" />
                                                </div>
                                                <div className="upload_profile_change">
                                                    <div className="upload_profile_change_content">
                                                        <span>
                                                            Change picture
                                                        </span>
                                                    </div>
                                                    <p>
                                                        Picture size 200 * 200
                                                        pixels and Max 200 KB{' '}
                                                    </p>
                                                </div>
                                            </div>
                                        </div> */}
                                        </div>
                                        <div className="btn_profile_submit">
                                            <Button
                                                className={
                                                    disableState() ||
                                                    profileData.email != defaultProfileData.email ||
                                                    profileData.phone_number != defaultProfileData.phone_number
                                                        ? 'editor_btn_disabled m-0'
                                                        : 'm-0 '
                                                }
                                                onClick={() => updateProfile()}
                                                disabled={
                                                    disableState() ||
                                                    profileData.email != defaultProfileData.email ||
                                                    profileData.phone_number != defaultProfileData.phone_number
                                                }
                                            >
                                                <label>Save Changes</label>
                                            </Button>
                                            {onSaveloading ? (
                                                <span>
                                                    <img src={LoadingSvgImage} />
                                                </span>
                                            ) : null}
                                        </div>
                                    </div>
                                )}
                                {profileView == 'Change password' && (
                                    <div className="login_bg_width_left_right_form">
                                        <UpdatePasswordUI workspace={props.match.params.workspacename} />
                                    </div>
                                )}
                                {profileView == 'Multi factor authentication' && (
                                    <div className="login_bg_width_left_right_form">
                                        <div className="col-md-12 col-lg-12 multi_factor">
                                            <h5>Protect your Workativ account with Multi-Factor Authentication</h5>
                                            <p>Each time users sign in to your Workativ Assistant, they will need a password and a verification code.</p>
                                           <div className='multi_factor_option'>
                                               <h5>Multi-Factor Authentication options</h5>
                                               <div className='multi_factor_option_box mb-2'>
                                                    <div className="switch_box box_1">
                                                        <input
                                                            type="checkbox" checked
                                                        />
                                                        <label>Email OTP verification</label>
                                                    </div>
                                                    {/* <div className="switch_box box_1">
                                                        <input
                                                            type="checkbox"
                                                        />
                                                        <label>Phone OTP verification</label>
                                                    </div>
                                                    <div className="switch_box box_1">
                                                        <input
                                                            type="checkbox"
                                                        />
                                                        <label>Authenticator app</label>
                                                    </div> */}
                                               </div>

                                           </div>
                                        </div>
                                        {/* <div className="btn_profile_submit">
                                            <Button>
                                                <label style={{top: 0}}>Cancel</label>
                                            </Button>
                                            <Button>
                                                <label style={{top: 0}}>Save</label>
                                            </Button>
                                        </div> */}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export function InputWithLabel(props: {
    value: string
    label: string
    placeHolder: string
    additionClass?: string
    children?: any
    type: string
    disabled: boolean
    onClick?: () => void
    onChange?: (value: string) => void
    elementError?: any
    maxLength?: number
    autoFocus?: boolean
}) {
    const inputRef = useRef<null | HTMLInputElement>(null)

    useEffect(() => {
        props.autoFocus && inputRef.current && inputRef.current.focus()
    }, [])
    return (
        <div className={!props.additionClass ? 'form-group ' : 'form-group' + ' ' + props.additionClass}>
            <InputWrapper>
                <InputContainer>
                    <Input
                        type={props.type}
                        onChange={(e: any) => (props.onChange ? props.onChange(e.target.value) : null)}
                        disabled={props.disabled}
                        value={props.value}
                        onClick={(e: any) => {
                            props.onClick ? props.onClick() : null
                        }}
                        maxLength={props.maxLength}
                        ref={inputRef}
                    />
                    <InputContent>{props.label}</InputContent>
                </InputContainer>
            </InputWrapper>
            {/* <label htmlFor={props.label}></label> */}
            {props.elementError && props.elementError}

            {props.children}
        </div>
    )
}

function reducer(state: any, action: Modes) {
    switch (action.type) {
        case Mode.eye:
            return {
                ...state,
                eye: {
                    ...state.eye,
                    [action.currentEyeKey]: !state.eye[action.currentEyeKey]
                }
            }
        case Mode.password:
            return {
                ...state,
                password: {
                    ...state.password,
                    [action.currentPasswordKey]: action.currentPasswordValue
                }
            }
        case Mode.initial:
            return action
        default:
            throw new Error()
    }
}

const errorInitialState = {
    currentPwdErr: false,
    newPwdErr: false,
    confirmPwdErr: false,
    msg: ''
}

function UpdatePasswordUI( props:any ) {
    const [disableSubmit, setDisableSubmit] = useState(false)
    const [logoutView, setLogoutView] = useState(false)
    const [error, setError] = useState(errorInitialState)
    const [state, dispatch] = useReducer(reducer, initialData)
    const [disableCancel, setDisableCancel] = useState(false)

    const [somethingWentWrong, setSomethingWentWrong] = useState(false)

    const updatePassword = () => {
        if (!PasswordRegex.test(state.password.new)) {
            setError({
                ...error,
                confirmPwdErr: false,
                msg: 'Invalid Password',
                newPwdErr: true,
                currentPwdErr: false
            })
            return
        } else if (state.password.current === state.password.new) {
            setError({
                ...error,
                newPwdErr: true,
                msg: 'Current and New password should not be same.',
                confirmPwdErr: false,
                currentPwdErr: false
            })
            return
        } else if (state.password.new !== state.password.confirm) {
            setError({
                ...error,
                confirmPwdErr: true,
                msg: 'Password does not match.',
                newPwdErr: false,
                currentPwdErr: false
            })
            return
        }
        const req = {
            old_password: state.password.current,
            new_password: state.password.new
        }

        putJson(updatePasswordUrl('/update_password'))()(req)
          .then((response) => {
            logEvent(props.workspace, {
              event: 'EVENT::PROFILE::UPDATE_PASSWORD',
              event_meta: {},
            });
            setError(errorInitialState);
            dispatch(initialData);
            setLogoutView(true);
          })
          .catch((err) => {
            if (err.response && err.response.status === 401) {
              setError({
                ...error,
                currentPwdErr: true,
                msg: 'This password might be invalid',
                confirmPwdErr: false,
                newPwdErr: false,
              });

              return;
            }

            if (
              err.response &&
              err.response.data &&
              err.response.data.validations &&
              err.response.data.validations.body &&
              err.response.data.validations.body[0] &&
              err.response.data.validations.body[0].property ===
                'request.body.old_password'
            ) {
              setError({
                ...error,
                currentPwdErr: true,
                msg: 'This password does not exist',
                confirmPwdErr: false,
                newPwdErr: false,
              });
            } else if (
              err.response &&
              err.response.data &&
              err.response.data.validations &&
              err.response.data.validations.body &&
              err.response.data.validations.body[0] &&
              err.response.data.validations.body[0].property ===
                'request.body.new_password'
            ) {
              setError({
                ...error,
                currentPwdErr: false,
                msg: 'Invalid password',
                confirmPwdErr: false,
                newPwdErr: true,
              });
            } else {
              setSomethingWentWrong(true);
            }
          });
    }

    useEffect(() => {
        const disableSubmit =
            state.password.current.length === 0 ||
            state.password.new.length === 0 ||
            state.password.confirm.length === 0
        setDisableSubmit(disableSubmit)

        const disableCancel =
            state.password.current.length === 0 &&
            state.password.new.length === 0 &&
            state.password.confirm.length === 0

        setDisableCancel(disableCancel)
    }, [state.password])

    const logOut = async () => {
        //Promise.resolve('logout')
        getJsonwithCredentials(loginApiURL('/logout'))
            .then((_: any) => {
                postMessage({ logout: true })
                location.reload()
            })
            .catch(err => {
                console.error('Unable to log-out')
            })
    }

    return (
        <>
            {logoutView ? (
                <Modal>
                    <div className="otp_popup">
                        <h4>Password Updated Successfully</h4>
                        <p>Password Updated, login to application with updated password</p>
                        <Button onClick={() => logOut()}>
                            <label className="otp_popup_label">Ok</label>
                        </Button>
                    </div>
                </Modal>
            ) : null}
            {somethingWentWrong ? (
                <Modal>
                    <div className="otp_popup">
                        <h5>Something went wrong. Please try again.</h5>
                        <Button
                            // className="otp_popup_buton"
                            onClick={() => {
                                setSomethingWentWrong(false)
                            }}
                        >
                            <label className="otp_popup_label">Okay</label>
                        </Button>
                    </div>
                </Modal>
            ) : null}
            <div className="user_cahnge_password">
                {
                    <>
                        <div className="user_cahnge_password_close form_w50 form_w50_pl">
                            <InputWithLabel
                                label="Current password"
                                type={!state.eye.currentPasswordEyeOpen ? 'password' : 'text'}
                                placeHolder="Enter current password"
                                disabled={false}
                                value={state.password.current}
                                additionClass={error.currentPwdErr ? 'form-group_error ' : ''}
                                onChange={v =>
                                    dispatch({
                                        ...PasswordType,
                                        currentPasswordKey: 'current',
                                        currentPasswordValue: v
                                    })
                                }
                                elementError={
                                    error.currentPwdErr && <span className="password-error">{error.msg}</span>
                                }
                            >
                                <CancelButton
                                    className="d-flex"
                                    onClick={() =>
                                        dispatch({
                                            ...EyeType,
                                            currentEyeKey: 'currentPasswordEyeOpen'
                                        })
                                    }
                                >
                                    {state.eye.currentPasswordEyeOpen ? <EyeOpenIcon /> : <EyeCloseIcon />}
                                </CancelButton>
                            </InputWithLabel>
                            <InputWithLabel
                                label="New password"
                                type={!state.eye.newPasswordEyeOpen ? 'password' : 'text'}
                                placeHolder="Enter new password"
                                additionClass={error.newPwdErr ? 'form-group_error' : ''}
                                disabled={false}
                                value={state.password.new}
                                onChange={v =>
                                    dispatch({
                                        ...PasswordType,
                                        currentPasswordKey: 'new',
                                        currentPasswordValue: v
                                    })
                                }
                                elementError={error.newPwdErr && <span className="password-error">{error.msg}</span>}
                            >
                                <CancelButton
                                    className="d-flex"
                                    onClick={() =>
                                        dispatch({
                                            ...EyeType,
                                            currentEyeKey: 'newPasswordEyeOpen'
                                        })
                                    }
                                >
                                    {state.eye.newPasswordEyeOpen ? <EyeOpenIcon /> : <EyeCloseIcon />}
                                </CancelButton>
                            </InputWithLabel>
                            <InputWithLabel
                                label="Confirm password"
                                type={!state.eye.confirmPasswordEyeOpen ? 'password' : 'text'}
                                additionClass={error.confirmPwdErr ? 'form-group_error' : ''}
                                placeHolder="Confirm password"
                                disabled={false}
                                value={state.password.confirm}
                                onChange={v =>
                                    dispatch({
                                        ...PasswordType,
                                        currentPasswordKey: 'confirm',
                                        currentPasswordValue: v
                                    })
                                }
                                elementError={
                                    error.confirmPwdErr && <span className="password-error">{error.msg}</span>
                                }
                            >
                                <CancelButton
                                    className="d-flex"
                                    onClick={() =>
                                        dispatch({
                                            ...EyeType,
                                            currentEyeKey: 'confirmPasswordEyeOpen'
                                        })
                                    }
                                >
                                    {state.eye.confirmPasswordEyeOpen ? <EyeOpenIcon /> : <EyeCloseIcon />}
                                </CancelButton>
                            </InputWithLabel>
                            <ButtonContainer className="p-0 justify-content-start" 
                                style={{ marginTop: 0 }}
                            >
                                <Button
                                    primary
                                    className={disableCancel ? 'editor_btn_disabled' : ''}
                                    onClick={() => {
                                        dispatch(initialData)
                                    }}
                                    disabled={disableCancel}
                                >
                                    <label>Cancel</label>
                                </Button>
                                <Button
                                    className={disableSubmit ? 'editor_btn_disabled' : ''}
                                    onClick={updatePassword}
                                    disabled={disableSubmit}
                                >
                                    <label>Update</label>
                                </Button>
                            </ButtonContainer>
                        </div>

                        <div className="user_password_info">
                            <div className="user_password_info_details">
                                <h6>Passwords are case sensitive and must contain:</h6>
                                <ul>
                                    <li>- Min 8 characters</li>
                                    <li>- At least 1 upper case letter</li>
                                    <li>- At least 1 lower case letter</li>
                                    <li>- At least 1 special character</li>
                                    <li>- At least 1 number</li>
                                </ul>
                            </div>
                        </div>
                    </>
                }
            </div>
        </>
    )
}
